import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectShop = (state: any) => state.shop;

export const selectCollections = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.collections,
);

export const selectIsAllCollectionsFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isAllCollectionsFetching,
);

export const selectBrands = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.brands,
);

export const selectBrandsPreview = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.brandsPreview,
);

export const selectIsAllBrandsFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isAllBrandsFetching,
);

export const selectCurrentCollectionItems = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentCollectionItems,
);

export const selectIsCollectionItemsFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isCollectionItemsFetching,
);

export const selectCurrentItem = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentItem,
);

export const selectIsItemFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isItemFetching,
);

export const selectCurrentCollection = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentCollection,
);

export const selectIsCollectionFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isCollectionFetching,
);

export const selectCurrentBrand = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentBrand,
);

export const selectIsBrandFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isBrandFetching,
);

export const selectCurrentFilterWithCount = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentFilterWithCount,
);

export const selectIsFilterWithCountFetching = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.isFilterWithCountFetching,
);

export const selectCurrentReviewsByProduct = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentReviewsByProduct,
);

export const selectCurrentReviewsByUser = createDraftSafeSelector(
  [selectShop],
  (shop) => shop.currentReviewsByUser,
);

export const selectPetCollection = createDraftSafeSelector(
  [selectCollections],
  (collections) => collections.petCollection,
);

export const selectJustInCollection = createDraftSafeSelector(
  [selectCollections],
  (collections) => collections.justInCollection,
);

export const selectJustInPreview = createDraftSafeSelector(
  [selectCollections],
  (collections) => collections.justInPreview,
);

export const selectSpecialCollection = createDraftSafeSelector(
  [selectCollections],
  (collections) => collections.specialCollection,
);

export const selectSpecialPreview = createDraftSafeSelector(
  [selectCollections],
  (collections) => collections.specialPreview,
);
